import Box from "ds/components/Box";
import useTypedFlags from "hooks/useTypedFlags";

import styles from "./styles.module.css";
import { TEST_PILOT_ANNOUNCEMENT_ID } from "./constants";
import DashboardOverviewColumnTestPilot from "./TestPilot";
import DashboardOverviewColumnAnnouncement from "./Announcement";
import { getBannerProps, shouldRenderBanner } from "./Announcement/helpers";
import useDashboardOverviewColumnDismissedAnnouncements from "./useDismissedAnnouncements";

const DashboardOverviewColumn = () => {
  const { feMarketingBanners, spaceliftTestPilotProgramDashboardWidget } = useTypedFlags();
  const { isDismissed } = useDashboardOverviewColumnDismissedAnnouncements();

  const visibleMarketingAnnouncements = feMarketingBanners
    .filter((banner) => shouldRenderBanner(banner.expirationDate) && !isDismissed(banner.id))
    .map((banner) => getBannerProps(banner.id))
    .filter((bannerProps) => bannerProps !== null);
  const isTestPilotVisible =
    spaceliftTestPilotProgramDashboardWidget && !isDismissed(TEST_PILOT_ANNOUNCEMENT_ID);

  if (!visibleMarketingAnnouncements.length && !isTestPilotVisible) {
    return null;
  }

  return (
    <Box
      className={styles.overviewColumn}
      gap="x-large"
      direction="column"
      padding="x-large x-large x-large 0"
    >
      {visibleMarketingAnnouncements.map((bannerProps) => (
        <DashboardOverviewColumnAnnouncement key={bannerProps.bannerId} {...bannerProps} />
      ))}
      {isTestPilotVisible && <DashboardOverviewColumnTestPilot />}
    </Box>
  );
};

export default DashboardOverviewColumn;
